import { createAsyncThunk } from '@reduxjs/toolkit';
import ax from 'services/apiService';

// master_data/batch_mdata
export const getBatchDetails = createAsyncThunk('batch-details', async (payload: any) => {
    try {
        const { data } = await ax.post(`api/api/master_data/batch_mdata`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response.data;
        }
    }
});
// api/master_data/add-batch
export const saveBatchDetails = createAsyncThunk('save-batch-details', async (payload: any) => {
    try {
        const { data } = await ax.post(`api/api/master_data/add-batch`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response.data;
        }
    }
});
// master_data/project_mdata
export const getProjectDetails = createAsyncThunk('project-details', async (payload: any) => {
    try {
        const { data } = await ax.post(`api/api/master_data/project_mdata`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response.data;
        }
    }
});
export const saveProjectMasterDetails = createAsyncThunk('add-project-details', async (payload: any) => {
    try {
        const { data } = await ax.post(`api/api/master_data/add-project`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response.data;
        }
    }
});
// master_data/candidatebatchinfo/95
export const getBatchInfo = createAsyncThunk('get-batch-details', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/master_data/get_batchinfo/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});
// menu/get_overall_candidates
export const getAllCandidates= createAsyncThunk('get-batch-candidates-all', async ( ) => {
    try {
        const { data } = await ax.get(`api/api/menu/get_overall_candidates`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response.data;
        }
    }
});
// get project batch
export const getProjectBatchInfo = createAsyncThunk('get-project-batch-details', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/master_data/get_projectinfo/${id}`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response.data);
        }
    }
});